import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const PRIVATE_ROUTES = ["/login", "/dashboard-secure-panel"];

const isPrivatePath = (pathname) =>
  PRIVATE_ROUTES.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`)
  );

const PublicSiteEffects = () => {
  const { pathname } = useLocation();
  const privateRoute = isPrivatePath(pathname);

  useEffect(() => {
    const body = document.body;
    const root = document.documentElement;
    const materializeStyles = document.getElementById("materialize-css");

    body.classList.toggle("public-site", !privateRoute);
    root.classList.toggle("public-site-root", !privateRoute);

    if (materializeStyles) {
      materializeStyles.media = privateRoute ? "not all" : "all";
    }

    return () => {
      if (privateRoute) {
        body.classList.remove("public-site");
        root.classList.remove("public-site-root");
        if (materializeStyles) materializeStyles.media = "not all";
      }
    };
  }, [privateRoute]);

  return null;
};

export default PublicSiteEffects;
